module.exports = __webpack_public_path__ + "static/img/pp-02.c1b4c377.jpg";